/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { IncidentVorlageDatenRequest } from '../model/incidentVorlageDatenRequest';
// @ts-ignore
import { IncidentVorlageIdentifier } from '../model/incidentVorlageIdentifier';
// @ts-ignore
import { IncidentVorlageRequest } from '../model/incidentVorlageRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class IncidentVorlageCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostIncidentVorlageAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * IncidentVorlageNichtGefunden: (IncidentVorlageNichtGefunden) * IncidentVorlageGeloescht: (IncidentVorlageGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/inc/command/incident-vorlagen/v1/aktualisieren
     * @param incidentVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postIncidentVorlageAktualisierenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncidentVorlageIdentifier>;
    public postIncidentVorlageAktualisierenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncidentVorlageIdentifier>>;
    public postIncidentVorlageAktualisierenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncidentVorlageIdentifier>>;
    public postIncidentVorlageAktualisierenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (incidentVorlageDatenRequest === null || incidentVorlageDatenRequest === undefined) {
            throw new Error('Required parameter incidentVorlageDatenRequest was null or undefined when calling postIncidentVorlageAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/inc/command/incident-vorlagen/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<IncidentVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incidentVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostIncidentVorlageAnlegenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) 
     * @endpoint post /api/inc/command/incident-vorlagen/v1/anlegen
     * @param incidentVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postIncidentVorlageAnlegenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncidentVorlageIdentifier>;
    public postIncidentVorlageAnlegenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncidentVorlageIdentifier>>;
    public postIncidentVorlageAnlegenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncidentVorlageIdentifier>>;
    public postIncidentVorlageAnlegenAdmin(incidentVorlageDatenRequest: IncidentVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (incidentVorlageDatenRequest === null || incidentVorlageDatenRequest === undefined) {
            throw new Error('Required parameter incidentVorlageDatenRequest was null or undefined when calling postIncidentVorlageAnlegenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/inc/command/incident-vorlagen/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<IncidentVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incidentVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostIncidentVorlageEntfernenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * IncidentVorlageNichtGefunden: (IncidentVorlageNichtGefunden) * IncidentVorlageGeloescht: (IncidentVorlageGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/inc/command/incident-vorlagen/v1/entfernen
     * @param incidentVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postIncidentVorlageEntfernenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncidentVorlageIdentifier>;
    public postIncidentVorlageEntfernenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncidentVorlageIdentifier>>;
    public postIncidentVorlageEntfernenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncidentVorlageIdentifier>>;
    public postIncidentVorlageEntfernenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (incidentVorlageRequest === null || incidentVorlageRequest === undefined) {
            throw new Error('Required parameter incidentVorlageRequest was null or undefined when calling postIncidentVorlageEntfernenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/inc/command/incident-vorlagen/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<IncidentVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incidentVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostIncidentVorlageKopierenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * IncidentVorlageNichtGefunden: (IncidentVorlageNichtGefunden) * IncidentVorlageGeloescht: (IncidentVorlageGeloescht) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/inc/command/incident-vorlagen/v1/kopieren
     * @param incidentVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postIncidentVorlageKopierenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<IncidentVorlageIdentifier>;
    public postIncidentVorlageKopierenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IncidentVorlageIdentifier>>;
    public postIncidentVorlageKopierenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IncidentVorlageIdentifier>>;
    public postIncidentVorlageKopierenAdmin(incidentVorlageRequest: IncidentVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (incidentVorlageRequest === null || incidentVorlageRequest === undefined) {
            throw new Error('Required parameter incidentVorlageRequest was null or undefined when calling postIncidentVorlageKopierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/inc/command/incident-vorlagen/v1/kopieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<IncidentVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: incidentVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
